module.exports = __webpack_public_path__ + "static/img/ts_professional.128feb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/ts_professional.jpg
// module id = ff5T
// module chunks = 0